<ng-container *transloco="let t">
  <section
    class="best-sellers-picker-component"
    [class.widescreen]="(biggerThan$ | async)?.mobileL"
    [class.largescreen]="(biggerThan$ | async)?.sm">
    <div class="flex justify-between full-width align-base">
      @if ((language$ | async) === 'ar') {
        <h3>صفقات قد تعجبك</h3>
      } @else {
        <h3>Deals you might like</h3>
      }
    </div>

    <span class="fixed-space-8" aria-hidden="true"></span>

    <div class="cards">
      <div class="card products flex flex-col">
        <nav class="filters">
          @for (category of productCategories(); track trackByKey) {
            <span
              class="badge"
              [class.selected]="filteredCategory() === category"
              (click)="switchCategory(category)">
              {{ t('label_popular') }}
              {{
                t(
                  'category_' +
                    (capitalizeCategory(category)?.toLowerCase() || '') +
                    '_title'
                )
              }}</span
            >
          }
        </nav>
        @if (filteredCategory() === null) {
          <app-popsy-scroller>
            @for (best of bestSellersApi(); track trackByKey) {
              <app-best-seller-card [product]="best" />
            }
          </app-popsy-scroller>
        } @else {
          <app-popsy-scroller>
            @for (best of bestSellersPerCategory(); track trackByKey) {
              <app-best-seller-card [product]="best" />
            }
          </app-popsy-scroller>
        }
      </div>
    </div>
  </section>
</ng-container>
